<script>
export default {
  emits: ['clicked'],
};
</script>

<template>
  <div class="flex flex-col items-center justify-center w-full mt-8">
    <slot name="img" />

    <h1 class="mt-5 text-2xl font-bold section-sub-title ">
      <slot name="title" />
    </h1>

    <p class="mt-4 text-lg font-medium text-center section-body">
      <slot name="description" />
    </p>

    <LpButton
      class="mt-8"
      data-testid="actionBtn"
      size="medium"
      @click="$emit('clicked')"
    >
      <slot name="buttonText" />
    </LpButton>
  </div>
</template>
